import Message from "./Message.tsx";

const ApiErrorMessage = ({
  error,
  message = "Une erreur est survenue :",
}: ApiErrorMessageType) => {
  const errorMessage = Array.isArray(error)
    ? error
        .map((error) => error.statusText)
        .filter(Boolean)
        .join(", ")
    : error.statusText;

  return <Message type="error" message={`${message} ${errorMessage}`} />;
};

type ApiErrorMessageType = {
  message: string;
  error: Response;
};

export default ApiErrorMessage;
